import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import RenderLoading from '../RenderLoading/RenderLoading';
import {checkstate} from '../service/service.supersalud';
import { isAuthenticate } from '../commons/utils';
import jwt_decode from 'jwt-decode';

 
const LoginNSerie = (props) => {
    let location = useLocation();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const { user, userLoggedIn } = props;
    

    useEffect(()=>{
        var searchParams = new URLSearchParams(location.search);
        const token = searchParams.get("token");
        const nombre = searchParams.get("nombre");
        const apePat = searchParams.get("apepat");
        const apeMat = searchParams.get("apemat");
        const telefono = searchParams.get("telefono");
        const correo = searchParams.get("correo");
        const estado = searchParams.get("state");
        const rut = searchParams.get("rut")
        
        if(estado==="true"){
            
           let usuario = {
            avatar:null,
            email: correo,
            last_name:apePat,
            mother_last_name: apeMat,
            names: nombre,
            phone_mobile: telefono,
            rut:rut,
            token:token
           } 
           userLoggedIn(usuario) 
           return history.push("/MediacionAseguradora");
        }else{
            return history.push("/login?claveunicaMessage=true"); 

        }

    
    },[])

    return (
        <div>
            {
                loading?<RenderLoading/>:null
            }
        </div>
    )
}

export default LoginNSerie;
